import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LastOfMonthPipe } from './last-of-month.pipe';

@NgModule({
  declarations: [LastOfMonthPipe],
  imports: [CommonModule],
  exports: [LastOfMonthPipe],
})
export class LastOfMonthPipeModule {}
